<script setup lang="ts">
import { Card } from 'ant-design-vue';
import { CSSProperties } from 'vue';

interface Props {
  title?: string | undefined;
  loading?: boolean;
  bodyStyle?: CSSProperties;
  headStyle?: CSSProperties;
  size?: 'small' | 'default';
}
const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  loading: false,
  bodyStyle: () => ({}),
  headStyle: () => ({}),
  size: 'small',
});
</script>

<template>
  <Card
    :title="props.title"
    :size="props.size"
    :loading="props.loading"
    :bodyStyle="bodyStyle"
    :headStyle="headStyle"
    :bordered="false"
  >
    <template #title>
      <slot name="title"></slot>
    </template>
    <slot></slot>
  </Card>
</template>

<style scoped></style>
